import * as ActionTypes from './types';
import { createAction } from '@reduxjs/toolkit';

export const removeMessage = createAction(ActionTypes.REMOVE_MESSAGE);
export const addErrorMessage = createAction(ActionTypes.ADD_ERROR_MESSAGE);
